import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { CurrentUserProvider } from '~/contexts/CurrentUser';
import { DrawerProvider } from '~/contexts/Drawer';
import Pages from '~/pages';
import themeStyles from '~/assets/styles/theme';
import '~/i18n';
import 'react-toastify/dist/ReactToastify.css';
import 'moment/locale/pt-br';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import OneSignal from 'react-onesignal';

const NODE_ENV = process.env.NODE_ENV;

// const events = [
  // {
  //   listener: 'on',
  //   event: 'subscriptionChange',
  //   callback: (isSubscribed) => {
  //     if (true === isSubscribed) {
  //       console.log('\n\n\n', 'The user subscription state is now:', isSubscribed, '\n\n\n');
  //     }
  //   },
  // },
  // {
  //   event: 'notificationDisplay',
  //   callback: (event) => {
  //     console.warn('\n\n\n', window.location.pathname, event, '\n\n\n');
  //     if (window.location.pathname === '/medical_appointments') {
  //       window.location.reload();
  //     }
  //   },
  // },
  // {
  //   event: 'notificationDismiss',
  //   callback: (event) => {
  //     console.warn('\n\n\n', 'OneSignal notification dismissed:', event, '\n\n\n');
  //   },
  // },
// ];

setTimeout(function() {
  const options = {
    allowLocalhostAsSecureOrigin: true,
    persistNotification: true,
    autoResubscribe: true,
    autoRegister: true,
    notifyButton: {
      enable: true,
      offset: {
        bottom: '60px'
      }
    }
  };

  if(NODE_ENV === 'production'){
    if(window.OneSignal && window.OneSignal.initialized){ return; }

    OneSignal.init({ appId: 'b0410414-3804-456d-9b8b-e483fa82b2f5', ...options });
    OneSignal.on('subscriptionChange', (isSubscribed) => {
      // if (true === isSubscribed) {
        console.log('\n\n\n', 'Response onesignal:', isSubscribed, '\n\n\n');
      // }
    });

    window.navigator.serviceWorker.register('/OneSignalSDKWorker.js');
    window.navigator.serviceWorker.register('/OneSignalSDKUpdaterWorker.js');
  }
}, 3000);

library.add(fab);
toast.configure();

const theme = createMuiTheme(themeStyles);

function AppRouter() {
  try {
    return (
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <CurrentUserProvider>
            <DrawerProvider>
              <CssBaseline />
              <Pages />
              <ToastContainer />
            </DrawerProvider>
          </CurrentUserProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  } catch(e){ console.log(e); }
}

export default AppRouter;
